// extracted by mini-css-extract-plugin
export var addButton = "_g2-0";
export var border = "_g2-8";
export var check = "_g2-h";
export var danger = "_g2-6";
export var dropdownContainer = "_g2-1";
export var editModalBody = "_g2-j";
export var footerContainer = "_g2-i";
export var fullWidth = "_g2-a";
export var hide = "_g2-9";
export var icon = "_g2-3";
export var input = "_g2-7";
export var inputFlex = "_g2-b";
export var inputWrapper = "_g2-c";
export var manualFocus = "_g2-5";
export var optionButton = "_g2-4";
export var pillWrapper = "_g2-e";
export var pointer = "_g2-2";
export var showOverflow = "_g2-f";
export var tagsFlex = "_g2-d";
export var xButton = "_g2-g";